import { render, staticRenderFns } from "./Alistamiento.vue?vue&type=template&id=20bd75ed&scoped=true"
import script from "./Alistamiento.vue?vue&type=script&lang=js"
export * from "./Alistamiento.vue?vue&type=script&lang=js"
import style0 from "./Alistamiento.vue?vue&type=style&index=0&id=20bd75ed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20bd75ed",
  null
  
)

export default component.exports